class DownloadImageButton {
	constructor() {
		this.btn = document.querySelectorAll('.image-download-btn--check');
		this.closeBtn = document.querySelector('.download-message-info__close-btn');
		this.message = document.querySelector('.download-message-info');
	}

	init() {
		if (this.btn) {
			this.btn.forEach(btn => btn.addEventListener('click', e => {
				e.preventDefault();
				fetch(e.target.dataset.status)
					.then(res => res.json())
					.then(status => {
						if (!status) {
							window.location = e.target.href;
						} else {
							this.message.style.display = 'block';
							this.message.style.opacity = 1;
						}
					})
					.catch(err => console.log('parsing failed', err));
			}));
		}
		if( this.closeBtn ){
			this.closeBtn.addEventListener('click', e => {
				e.preventDefault();
				this.message.style.opacity = 0;
				setTimeout(() => {
					this.message.style.display = 'none';
				}, 300);
			});
		}
	}
}

export default DownloadImageButton;


// WEBPACK FOOTER //
// ./js/components/DownloadImageButton.js